import BaseAudienceOperationDebugResponse from "./BaseAudienceOperationDebugResponse";
export default class ActionAudienceOperationDebugResponse extends BaseAudienceOperationDebugResponse {
    constructor(response) {
        super(response);
    }
}
